import * as page from './page';
import { PAGES } from '../constants';

const statePath = ['pages', PAGES.API_TOKENS];

export const create = ({
  payload = {}
}) => page.createOne({ payload, statePath })

export const fetchList = ({
  pageNum = 1,
  perPage = 20
}) => page.fetchList({
  statePath,
  query: { pageNum, perPage }
})

export const regenerate = ({
  tokenId,
  pageNum = 1,
  perPage = 20
}) => page.regenerateAPIToken({
  statePath,
  tokenId,
  pageNum,
  perPage
});

export const remove = ({
  tokenId,
  pageNum = 1,
  perPage = 20
}) => page.removeAPIToken({
  statePath,
  tokenId,
  pageNum,
  perPage
});



// WEBPACK FOOTER //
// ./webAdmin/actions/apiTokens.js